module.exports = __webpack_public_path__ + "static/media/receipt.a531812d.svg";